import { useEffect, useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import SuccessStoryCard from "@/components/SuccessStoryCard";
import api from "@/lib/api";

export default function SuccessStories() {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/success-stories").then((res) => {
      setCases(res.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-amtm-bg">
      <PublicHeader />
      <section className="max-w-6xl mx-auto px-6 md:px-12 py-12 md:py-20">
        <div className="text-center mb-12">
          <Sparkles className="h-10 w-10 text-amtm-teal mx-auto mb-4" />
          <h1 className="font-display text-4xl sm:text-5xl text-amtm-text mb-4">Success Stories</h1>
          <p className="text-amtm-textMuted max-w-xl mx-auto">Every one of these animals was rescued, treated, and given a second chance thanks to your support.</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-16" data-testid="success-stories-loading">
            <Loader2 className="h-8 w-8 animate-spin text-amtm-teal" />
          </div>
        ) : cases.length === 0 ? (
          <p className="text-center text-amtm-textMuted py-16" data-testid="success-stories-empty">No success stories published yet.</p>
        ) : (
          <div className="grid sm:grid-cols-2 gap-8" data-testid="success-stories-grid">
            {cases.map((c) => (
              <SuccessStoryCard key={c.id} caseItem={c} />
            ))}
          </div>
        )}
      </section>
      <PublicFooter />
    </div>
  );
}
